


























































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";

import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "loginauthignore/list";

  dispatchTypeDelete = "loginauthignore/delete";

  deleteConfirmContent = "确认要删除该内容吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id", sorter: true },
    { title: "服务", dataIndex: "service_name" },
    { title: "url", dataIndex: "url_expression" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
